import { applyTokens } from './applyTokens'

// Extended style type that includes custom properties from the theme system
export type AppliedStyles = Record<string, unknown>

export const applyStyles = (
  tokenConfig: Record<string, unknown>,
  componentConfig: Record<string, { variants?: Record<string, unknown> } & Record<string, unknown>>,
  breakpoint: number,
  tokens: Record<string, unknown>,
  componentName?: string,
  variantName?: string
): AppliedStyles => {
  const appliedTokens: AppliedStyles = {}

  if (componentName) {
    if (!componentConfig[componentName]) {
      console.warn(
        'Component name specified but no config found',
        componentName
      )
    } else {
      const { variants, ...componentGeneralConfig } =
        componentConfig[componentName]

      Object.assign(
        appliedTokens,
        applyTokens(tokenConfig, breakpoint, componentGeneralConfig)
      )

      if (variantName && variants && variants[variantName]) {
        Object.assign(
          appliedTokens,
          applyTokens(tokenConfig, breakpoint, variants[variantName] as Record<string, unknown>)
        )
      }
    }
  }

  Object.assign(appliedTokens, applyTokens(tokenConfig, breakpoint, tokens))

  return appliedTokens
}
